import { hasOwn, mapArrayToObject } from "../commonFunctions/arrayFunc";
import { newProcessLayout } from "./GridLayoutFunc";
import { getAllScreens } from "./screenutils";

class InitialRenderingData {
  static getInitialConfigOfDesktopRecordsview(currentConfig, table) {
    const { tableObject } = table;
    const { layout } = currentConfig.config;

    // all id array of table
    // const allFieldsIdFromTable = Object.keys(tableObject);
    // create a new columns for acording to table
    const newColumns = [];
    const newColumnsIdsArray = [];
    layout.columns.forEach((col) => {
      if (tableObject[col.id]) {
        newColumns.push({ ...col, ...tableObject[col.id], config: col.config ? col.config : {} }); // TODO: remove config key and try to add when column create
        newColumnsIdsArray.push(col.id);
      }
      if (col.type === "custom") {
        if (col.custom_type === "rich_column" && col.layout_config && Array.isArray(col.layout_config.layouts)) {
          col.layout_config.layouts.forEach((layout) => {
            if (layout.element_config && layout.element_config.id) {
              newColumnsIdsArray.push(layout.element_config.id);
            }
          });
        }
        newColumns.push(col);
      }
    });

    let newFilterArray = [];
    layout.onscreen_filters.forEach((obj) => {
      if (newColumnsIdsArray.includes(obj.id)) {
        newFilterArray.push({ ...obj, ...tableObject[obj.id] });
      }
    });

    let newPrefiltersArray = [];
    layout.pre_filters?.forEach((obj) => {
      if (tableObject[obj.id]) {
        newPrefiltersArray.push({
          ...obj,
          ...tableObject[obj.id]
        });
      }
    });
    let newLocationPoint;
    if (hasOwn(layout, "location_point")) {
      newLocationPoint = tableObject[layout.location_point]?.id || "";
    }
    let obj = {
      columns: newColumns,
      onscreen_filters: newFilterArray,
      pre_filters: newPrefiltersArray
    };
    if (hasOwn(layout, "location_point")) {
      obj.location_point = newLocationPoint;
    }

    const newLayout = { ...layout, ...obj };

    const newConfig = JSON.parse(JSON.stringify(currentConfig));
    newConfig.config.layout = newLayout;
    return newConfig;
  }

  static getInitialConfigOfMobileRecordsview(currentConfig) {
    const { layout } = currentConfig.config;
    let layoutCopy = { ...layout };
    if (layoutCopy?.style) {
      if (!layoutCopy.style.static_bar_color) {
        layoutCopy.style.static_bar_color = { show_color: true, color: "#4A1FB8" };
      }

      if (!layoutCopy.style.dynamic_bar_color) {
        layoutCopy.style.dynamic_bar_color = {
          show_dynamic_color: false,
          selected_dynamic_field: null,
          color_config: [{ value: "", color: "" }]
        };
      }
    } else {
      layoutCopy = {
        ...layoutCopy,
        style: {
          static_bar_color: { show_color: true, color: "#4A1FB8" },
          dynamic_bar_color: {
            show_dynamic_color: false,
            selected_dynamic_field: null,
            color_config: [{ value: "", color: "" }]
          }
        }
      };
    }

    const headerData = { ...layoutCopy.header };
    const footerData = { ...layoutCopy.footer };
    const newLayout = layoutCopy;
    return { headerData, footerData, newLayout };
  }

  static getInitialConfigOfDetailsView(currentConfig, table) {
    const { tableObject } = table;
    let configElements = currentConfig;

    if (!configElements || !configElements.elements) {
      return { layout: [], layoutData: {}, nestedGridData: {} };
    }

    // loop elements and saperate out grid ans element_config
    const nestedGridData = {};
    const layoutData = {};
    let layout = [];

    const processElement = (element, layoutData, nestedGridData) => {
      const { element_config, grid } = element;

      if (element_config.type === "tabview") {
        element_config.config.headerData.forEach((head) => {
          nestedGridData[head.id] = [];
          element_config.config.bodyData[head.id].forEach((nestedElement) => {
            const gridItem = processElement(nestedElement, layoutData, nestedGridData);
            if (!gridItem) {
              return;
            }
            nestedGridData[head.id] = [...nestedGridData[head.id], gridItem];
          });
        });
      }
      if (element_config.type === "section") {
        let nestedGrid = [];
        element_config.config.layouts?.forEach((nestedElement) => {
          const gridItem = processElement(nestedElement, layoutData, nestedGridData);
          if (!gridItem) {
            return;
          }
          nestedGrid = [...nestedGrid, gridItem];
        });
        nestedGridData[grid.i] = nestedGrid;
      }

      if (element_config.type === "field") {
        if (!tableObject[element_config.id]) {
          return null;
        }
        // if (element_config.field_type === "recordset-list" || element_config.field_type === "recordset") {
        //   let nestedGrid = [];
        //   element_config.config.layouts?.forEach((nestedElement) => {
        //     const gridItem = processElement(nestedElement, layoutData, nestedGridData);
        //     if (!gridItem) {
        //       return;
        //     }
        //     nestedGrid = [...nestedGrid, gridItem];
        //   });
        //   nestedGridData[grid.i] = nestedGrid;
        // }
        layoutData[grid.i] = { ...element_config, ...tableObject[element_config.id] };
      } else {
        layoutData[grid.i] = element_config;
      }
      return grid;
    };

    configElements?.elements?.forEach((element) => {
      const gridItem = processElement(element, layoutData, nestedGridData);
      if (!gridItem) {
        return;
      }
      layout = [...layout, gridItem];
    });

    //for detailview template image_data inside config
    if (configElements.image_data) {
      return { layout, layoutData, nestedGridData, image_data: configElements.image_data };
    }
    return { layout, layoutData, nestedGridData };
  }

  static getInitialPivotChartConfig(currentConfig, tableData) {
    const newConfig = InitialRenderingData.getInitialConfigOfDesktopRecordsview(currentConfig, tableData);

    let newLayout = [];
    let newLayoutData = [];

    currentConfig.config.layout?.pivot_charts?.forEach((pivotConfig) => {
      const id = pivotConfig.element_config.id;
      newLayout.push(pivotConfig.grid);
      newLayoutData[id] = pivotConfig.element_config;
    });

    return { newLayout, newLayoutData, newConfig: newConfig.config.layout };
  }

  static getInitialConfigOfChart(currentConfig, table) {
    const { tableObject } = table;
    const { charts, global_filters } = currentConfig.config;

    const layout = [];
    const layoutData = {};

    // handle charts
    charts.forEach((chart) => {
      const { grid, element_config } = chart;
      layout.push(grid);

      // handle group columns
      const newGroupColumn = [];
      element_config.group_columns.forEach((col) => {
        if (tableObject[col.column]) {
          newGroupColumn.push({ ...col, ...tableObject[col.column] });
        }
      });

      //   handle aggregate column
      const newAggregateColumn = tableObject[element_config.aggregate_column]?.id || "";

      const newConfig = {
        ...element_config,
        group_columns: newGroupColumn,
        aggregate_column: newAggregateColumn
      };

      layoutData[grid.i] = newConfig;
    });

    // handle global filter
    const { fields, pre_filters } = global_filters;
    const newFields = [];
    fields.forEach((field) => {
      if (tableObject[field.id]) {
        newFields.push({ ...field, ...tableObject[field.id] });
      }
    });

    const newPrefilter = [];
    pre_filters.forEach((field) => {
      if (tableObject[field.id]) {
        newPrefilter.push({ ...field, ...tableObject[field.id] });
      }
    });

    const newGlobalFilters = {
      ...global_filters,
      fields: newFields,
      pre_filters: newPrefilter
    };

    return {
      layout,
      layoutData,
      newGlobalFilters
    };
  }

  static getInitialConfigOfScreen(currentConfig, screens) {
    const { config, name, device, header_config, z_admin_config, module_header_config } = currentConfig;
    if (name === "header") {
      const initialLogoData = {
        logosrc: "",
        logosize: "",
        logotext: "",
        logotextsize: "",
        logotextweight: "",
        logotextcolor: "#000000"
      };
      const initialStyle = {
        nav_position: "top",
        nav_fixed: false
      };

      // make all screen as object
      const index = device === "desktop" ? 0 : 1;
      const { result: allScreenObject } = mapArrayToObject(screens[index].items);
      // filter out screen present in header or not
      const filterItems = (items) => {
        const result = [];
        items?.forEach((item) => {
          if (item.type === "dropdown") {
            const filteredChildren = filterItems(item.dropdown || []);
            result.push({ ...item, dropdown: filteredChildren });
          } else if (allScreenObject[item.page_id]) {
            result.push({ ...item, display: allScreenObject[item.page_id].name });
          }
        });
        return result;
      };
      const normalizedMenu = normalizeMenuItems(header_config?.menu);
      const normalizedMenuBottom = normalizeMenuItems(header_config?.menu_bottom);
      const newMenu = filterItems(normalizedMenu);
      const bottomMenu = filterItems(normalizedMenuBottom);
      const newHeader = {
        menu: newMenu || [],
        logo: header_config.logo || initialLogoData,
        style: header_config.style || initialStyle,
        menu_bottom: bottomMenu || []
      };
      return { header_config: newHeader, z_admin_config, module_header_config };
    } else {
      let layout = [];
      const layoutData = {};
      const nestedGridData = {};

      const processElement = (element, layoutData, nestedGridData) => {
        const { element_config, grid } = element;
        if (element_config.type === "tabview") {
          element_config.config.headerData.forEach((head) => {
            nestedGridData[head.id] = [];
            element_config.config.bodyData[head.id].forEach((nestedElement) => {
              const gridItem = processElement(nestedElement, layoutData, nestedGridData);
              if (!gridItem) {
                return;
              }
              nestedGridData[head.id] = [...nestedGridData[head.id], gridItem];
            });
          });
        }
        if (element_config.type === "section") {
          let nestedGrid = [];
          element_config.config.layouts.forEach((nestedElement) => {
            const gridItem = processElement(nestedElement, layoutData, nestedGridData);
            if (!gridItem) {
              return;
            }
            nestedGrid = [...nestedGrid, gridItem];
          });
          nestedGridData[grid.i] = nestedGrid;
        }

        layoutData[grid.i] = element_config;

        return grid;
      };

      config?.layout?.forEach((element) => {
        const gridItem = processElement(element, layoutData, nestedGridData);
        if (!gridItem) {
          return;
        }
        layout = [...layout, gridItem];
      });

      return { layout, layoutData, nestedGridData };
    }
  }

  // static getInitialConfigOfKanban(currentBlockConfig, data) {
  // const nonSelectArray = data.states.filter(
  //   (state) => !currentBlockConfig.config.data.states.some((currentState) => currentState.id === state.id)
  // );
  // const newObj = data.states.reduce((acc, state) => {
  //   acc = { ...acc, [state.id]: state };
  //   return acc;
  // }, {});
  // }
}

export default InitialRenderingData;

export const getUpdatedDataOfRVColumnsAndFilters = (config, tableData) => {
  const { tableObject } = tableData;

  const newColumns = [];
  const newColumnsIdsArray = [];
  config.columns.forEach((col) => {
    if (tableObject[col.id]) {
      newColumns.push({ ...col, ...tableObject[col.id] });
      newColumnsIdsArray.push(col.id);
    }
    if (col.type === "custom") {
      if (col.custom_type === "rich_column" && col.layout_config && Array.isArray(col.layout_config.layouts)) {
        col.layout_config.layouts.forEach((layout) => {
          if (layout.element_config && layout.element_config.id) {
            newColumnsIdsArray.push(layout.element_config.id);
          }
        });
      }
      newColumns.push(col);
    }
  });

  let newFilterArray = [];
  config.onscreen_filters.forEach((obj) => {
    if (newColumnsIdsArray.includes(obj.id)) {
      newFilterArray.push({ ...obj, ...tableObject[obj.id] });
    }
  });

  let newPrefiltersArray = [];
  config.pre_filters?.forEach((obj) => {
    if (tableObject[obj.id]) {
      newPrefiltersArray.push({
        ...obj,
        ...tableObject[obj.id]
      });
    }
  });
  return {
    columns: newColumns,
    // onscreen_filters: newFilterArray,
    onscreen_filters: config.onscreen_filters,
    pre_filters: newPrefiltersArray
  };
};

export const getLayoutDataOfDetailviewElements = (elements, tableData) => {
  const { tableObject } = tableData;

  if (!elements) {
    return { layout: [], layoutData: {}, nestedGridData: {} };
  }

  const nestedGridData = {};
  const layoutData = {};
  let layout = [];

  const processElement = (element, layoutData, nestedGridData) => {
    const { element_config, grid } = element;

    if (element_config.type === "tabview") {
      element_config.config.headerData.forEach((head) => {
        nestedGridData[head.id] = [];
        element_config.config.bodyData[head.id].forEach((nestedElement) => {
          const gridItem = processElement(nestedElement, layoutData, nestedGridData);
          if (!gridItem) {
            return;
          }
          nestedGridData[head.id] = [...nestedGridData[head.id], gridItem];
        });
      });
    }
    if (element_config.type === "section") {
      let nestedGrid = [];
      element_config.config.layouts?.forEach((nestedElement) => {
        const gridItem = processElement(nestedElement, layoutData, nestedGridData);
        if (!gridItem) {
          return;
        }
        nestedGrid = [...nestedGrid, gridItem];
      });
      nestedGridData[grid.i] = nestedGrid;
    }

    if (element_config.type === "field") {
      if (!tableObject[element_config.id]) {
        return null;
      }
      layoutData[grid.i] = { ...element_config, ...tableObject[element_config.id] };
    } else {
      layoutData[grid.i] = element_config;
    }
    return grid;
  };

  elements?.forEach((element) => {
    const gridItem = processElement(element, layoutData, nestedGridData);
    if (!gridItem) {
      return;
    }
    layout = [...layout, gridItem];
  });

  return { layout, layoutData, nestedGridData };
};

export const getInitialConfigOfScreen = (config, screens) => {
  let newConfig;
  const copyConfig = JSON.parse(JSON.stringify(config));
  if (config.name === "header") {
    newConfig = getInitialConfigOfHeaderScreen(copyConfig, screens);
  } else {
    newConfig = getInitialConfigOfDefaultScreen(copyConfig);
  }
  return JSON.parse(JSON.stringify(newConfig));
};

const getInitialConfigOfDefaultScreen = (screenConfig) => {
  const lay = processScreenElement(screenConfig.config?.layout || []);

  const { layout, layoutData, nestedGridData } = lay;
  let { elements } = newProcessLayout(layoutData, nestedGridData, layout);

  const newConfig = { ...screenConfig };
  newConfig.config.layout = elements;
  return { config: newConfig, layout: lay };
};

export const normalizeMenuItems = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    const normalized = { ...item };

    // Ensure all required keys exist matching backend ScreenConfigMenu struct
    normalized.display = normalized.display || normalized.name || "";
    normalized.icon = normalized.icon ?? "";
    normalized.allowed_groups = normalized.allowed_groups ?? null;

    const hasDropdownChildren = Array.isArray(normalized.dropdown) && normalized.dropdown.length > 0;
    if (hasDropdownChildren) {
      normalized.type = "dropdown";
      normalized.page_id = "";
      normalized.dropdown = normalizeMenuItems(normalized.dropdown);
    } else {
      normalized.type = "page";
      normalized.page_id = normalized.page_id || "";
      normalized.dropdown = [];
    }
    return normalized;
  });
};

const filterMenuItems = (items, allScreenObject) => {
  const result = [];
  items?.forEach((item) => {
    if (item.type === "dropdown") {
      const filteredChildren = filterMenuItems(item.dropdown || [], allScreenObject);
      result.push({ ...item, dropdown: filteredChildren });
    } else if (allScreenObject[item.page_id]) {
      result.push({ ...item, display: allScreenObject[item.page_id].name });
    }
  });
  return result;
};

const getInitialConfigOfHeaderScreen = (config, screens) => {
  const initialLogoData = {
    logosrc: "",
    logosize: "",
    logotext: "",
    logotextsize: "",
    logotextweight: "",
    logotextcolor: "#000000"
  };
  const initialStyle = {
    nav_position: "top",
    nav_fixed: false
  };
  const { header_config } = config;

  const deviceScreens = screens.find((s) => s.id === config.device);
  const processFolderScreens = getAllScreens(deviceScreens.items);
  const { error, result: allScreenObject } = mapArrayToObject(processFolderScreens);
  if (error) {
    return config;
  }

  const normalizedMenu = normalizeMenuItems(header_config?.menu);
  const normalizedMenuBottom = normalizeMenuItems(header_config?.menu_bottom);
  const newMenu = filterMenuItems(normalizedMenu, allScreenObject);
  const bottomMenu = filterMenuItems(normalizedMenuBottom, allScreenObject);
  const newHeader = {
    menu: newMenu || [],
    logo: header_config.logo || initialLogoData,
    style: header_config.style || initialStyle,
    menu_bottom: bottomMenu || []
  };
  const newConfig = { ...config };
  newConfig.header_config = { ...newConfig.header_config, ...newHeader };
  return { config: newConfig };
};

const processScreenElement = (elements) => {
  let layout = [];
  const layoutData = {};
  const nestedGridData = {};

  const processElement = (element, layoutData, nestedGridData) => {
    const { element_config, grid } = element;
    if (element_config.type === "tabview") {
      element_config.config.headerData.forEach((head) => {
        nestedGridData[head.id] = [];
        element_config.config.bodyData[head.id].forEach((nestedElement) => {
          const gridItem = processElement(nestedElement, layoutData, nestedGridData);
          if (!gridItem) {
            return;
          }
          nestedGridData[head.id] = [...nestedGridData[head.id], gridItem];
        });
      });
    }
    if (element_config.type === "section") {
      let nestedGrid = [];
      element_config.config.layouts.forEach((nestedElement) => {
        const gridItem = processElement(nestedElement, layoutData, nestedGridData);
        if (!gridItem) {
          return;
        }
        nestedGrid = [...nestedGrid, gridItem];
      });
      nestedGridData[grid.i] = nestedGrid;
    }

    layoutData[grid.i] = element_config;

    return grid;
  };

  elements?.forEach((element) => {
    const gridItem = processElement(element, layoutData, nestedGridData);
    if (!gridItem) {
      return;
    }
    layout = [...layout, gridItem];
  });
  return { layout, layoutData, nestedGridData };
};

export const getInitialConfigOfDetailsView = (dvConfig, tableData) => {
  const newConfig = JSON.parse(JSON.stringify(dvConfig));
  const lay = getLayoutDataOfDetailviewElements(dvConfig.data.elements || [], tableData);
  const { layout, layoutData, nestedGridData } = lay;
  let { elements, uniqueFields, uniqueIds } = newProcessLayout(layoutData, nestedGridData, layout);
  newConfig.data = {
    ...newConfig.data,
    elements: elements,
    data_fields: uniqueFields,
    unique_ids: uniqueIds
  };
  return { config: newConfig, layout: lay };
};

export const getInitialConfigOfMapview = (mapConfig, tableData) => {
  const newConfig = JSON.parse(JSON.stringify(mapConfig));
  const updatedLayoutData = getUpdatedDataOfRVColumnsAndFilters(
    {
      columns: mapConfig.config.layout.columns,
      onscreen_filters: mapConfig.config.layout.onscreen_filters,
      pre_filters: mapConfig.config.layout.pre_filters
    },
    tableData
  );
  newConfig.config.layout = { ...mapConfig.config.layout, ...updatedLayoutData };
  return {
    config: newConfig
  };
};

// export const getInitialConfigOfChart = (chartConfig, tableData) => {
//   const newConfig = JSON.parse(JSON.stringify(chartConfig));
//   const newFilters = getUpdatedChartColumnAndFilters(chartConfig.config.global_filters, tableData);
//   const w = getUpdatedChartsLayout(chartConfig.config.charts, tableData);
//   const newCharts = processChartLayout(w.layout, w.layoutData);
//   newConfig.config.global_filters = newFilters;
//   newConfig.config.charts = newCharts;
//   return {
//     config: newConfig,
//     layout: {
//       layout: w.layout,
//       layoutData: w.layoutData
//     }
//   };
// };

// const getUpdatedChartColumnAndFilters = (global_filters, tableData) => {
//   const { tableObject } = tableData;
//
//   // handle global filter
//   const { fields, pre_filters } = global_filters;
//   const newFields = [];
//   fields.forEach((field) => {
//     if (tableObject[field.id]) {
//       newFields.push({ ...field, ...tableObject[field.id] });
//     }
//   });
//
//   const newPrefilter = [];
//   pre_filters.forEach((field) => {
//     if (tableObject[field.id]) {
//       newPrefilter.push({ ...field, ...tableObject[field.id] });
//     }
//   });
//
//   const newGlobalFilters = {
//     ...global_filters,
//     fields: newFields,
//     pre_filters: newPrefilter
//   };
//   return newGlobalFilters;
// };

export const processChartLayout = (layout, layoutData) => {
  const chartsArray = [];
  layout.forEach((item) => {
    const obj = {
      grid: item,
      element_config: layoutData[item.i]
    };
    chartsArray.push(obj);
  });
  return chartsArray;
};
export const getInitialConfigOfActivityCard = (cardConfig, tableData) => {
  const newConfig = JSON.parse(JSON.stringify(cardConfig));
  const lay = getLayoutDataOfDetailviewElements(cardConfig.data.elements || [], tableData);
  const { layout, layoutData, nestedGridData } = lay;
  let { elements, uniqueFields, uniqueIds } = newProcessLayout(layoutData, nestedGridData, layout);
  newConfig.data = {
    ...newConfig.data,
    elements: elements,
    data_fields: uniqueFields,
    unique_ids: uniqueIds
  };
  return { config: newConfig, layout: lay };
};

export const getInitialConfigOfKanban = (kanbanConfig, tableData) => {
  const newConfig = JSON.parse(JSON.stringify(kanbanConfig));
  const lay = getLayoutDataOfDetailviewElements(kanbanConfig.config.data.elements, tableData);
  const { layout, layoutData, nestedGridData } = lay;
  let { elements } = newProcessLayout(layoutData, nestedGridData, layout);
  newConfig.config.data.elements = elements;
  return { config: newConfig, layout: lay };
};
